import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-goback",
  "use": "icon-goback-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-goback\"><defs><style type=\"text/css\"></style></defs><path d=\"M496.691 379.136V227.874L137 482.655l359.691 254.781V587.535c143.958 0.045 277.437 7.303 390.309 208.591 0-127.845-21.135-413.405-390.309-416.99z\" fill=\"#2580FA\" p-id=\"5551\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol